// extracted by mini-css-extract-plugin
module.exports = {"container":"searchbar_container__Mqswi","logosearch":"searchbar_logosearch__S_9t6","iconSearch":"searchbar_iconSearch__Xq10K"};